import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class MobileNumbersService {
  constructor() {}

  //#region  Text input
  getCorrectMobileNumbersFromText(
    text: string,
    isInternationalNumber: boolean = false
  ): string[] {
    if (text.trim()) {
      let mobileNumbersArray = this.separateMobileNumbersFromText(
        text,
        isInternationalNumber
      );

      let mobileNumberBeginWith98Array =
        this.convertMobileNumberPrefixTo98FromArray(
          mobileNumbersArray,
          isInternationalNumber
        );
      // return mobileNumberBeginWith98Array;
      return this.removeDuplicateMobileNumberFromArray(
        mobileNumberBeginWith98Array
      );
    }
  }

  getWrongMobileNumbersFromText(
    text: string,
    isInternationalNumber: boolean = false
  ): string[] {
    if (text.trim()) {
      if (!isInternationalNumber)
        return text.getWrongMobileNumber().splitByNewLine().removeBlankItem();
      else
        return text
          .getWrongGlobalMobileNumber()
          .splitByNewLine()
          .removeBlankItem();
    }
  }

  //get duplicated numbers
  getDuplicatedMobileNumbers(mobileNumberArray: string[]): string[] {
    const findDuplicates = (mobileNumberArray) =>
      mobileNumberArray
        ?.map((item, index) => {
          if (mobileNumberArray.indexOf(item) !== index) return item;
        })
        .filter((mobile) => mobile);

    const duplicatedItems = findDuplicates(mobileNumberArray);
    return duplicatedItems;
  }

  separateMobileNumbersFromText(
    text: string,
    isInternationalNumber: boolean = false
  ): string[] {
    if (text.trim()) {
      if (!isInternationalNumber) return text.convertToMobileNumberArray();
      else return text.convertToGlobalMobileNumberArray();
    }
  }
  //#endregion

  //#region  Array input
  removeDuplicateMobileNumberFromArray(mobileNumberArray: string[]): string[] {
    if (mobileNumberArray && mobileNumberArray?.length > 0)
      return mobileNumberArray.removeDuplicateData();
  }

  convertMobileNumberPrefixTo98FromArray(
    mobileNumberArray: string[],
    isInternationalNumber: boolean = false
  ): string[] {
    if (
      mobileNumberArray &&
      mobileNumberArray?.length > 0 &&
      isInternationalNumber
    )
      return [...mobileNumberArray?.toStringBetweenNewLine().splitByNewLine()];

    if (
      mobileNumberArray &&
      mobileNumberArray?.length > 0 &&
      !isInternationalNumber
    )
      return [
        ...mobileNumberArray
          ?.toStringBetweenNewLine()
          .convertMobileNumberPrefixTo98()
          .splitByNewLine(),
      ];
  }

  getDuplicateMobileNumberFromArray(mobileNumberArray: string[]): string[] {
    return mobileNumberArray.removeDuplicateData();
  }
  //#endregion
}
